<template>
  <div class="main">
    <van-form @submit="checkPublish">
      <van-field
        v-model="form.cityName"
        label-class="left-title"
        input-align="right"
        readonly
        clickable
        required
        name="cityName"
        label="城市"
        placeholder="点击选择城市"
        @click="$router.push('/position')"
      />

      <van-field
        v-model="form.districtName"
        label-class="left-title"
        input-align="right"
        readonly
        clickable
        name="name"
        label="区域"
        placeholder="点击选择区域"
        @click="choose('districtList', 'name', 'districtName')"
      />

      <van-field
        v-model="form.title"
        label-class="left-title"
        input-align="right"
        label="标题"
        name="title"
        placeholder="请输入标题"
        @blur="onBlur"
      />

      <div class="border" />

      <van-field
        v-model="form.acreage"
        input-align="right"
        label="面积"
        name="acreage"
        type="number"
        placeholder="请输入面积(0为面议)"
        @blur="onBlur"
      >
        <template #button>
          ㎡
        </template>
      </van-field>

      <van-field
        v-model="form.transferFee"
        input-align="right"
        label="价格"
        type="number"
        name="transferFee"
        placeholder="请输入价格(0为面议)"
        @blur="onBlur"
      >
        <template #button>
          万元
        </template>
      </van-field>

      <div class="border" />

      <van-field
        v-model="form.contact"
        input-align="right"
        label="联系人"
        name="contact"
        placeholder="请输入联系人"
        @blur="onBlur"
      />

      <van-field
        v-model="form.phone"
        input-align="right"
        label="联系电话"
        name="phone"
        type="tel"
        required
        oninput="if (value.length > 11) value = value.slice(0, 11)"
        placeholder="请输入联系电话"
        @blur="onBlur"
      />

      <van-field
        v-model="form.address"
        input-align="right"
        label="详细地址"
        name="address"
        placeholder="请输入详细地址"
        @blur="onBlur"
      />

      <div class="border" />

      <van-field
        v-model="form.description"
        input-align="right"
        rows="2"
        autosize
        label="描述"
        type="textarea"
        maxlength="500"
        placeholder="可填写备注信息，没有可不填"
        show-word-limit
        @blur="onBlur"
      />

      <van-popup v-model="show" close-on-popstate position="bottom">
        <van-picker
          show-toolbar
          :columns="columns"
          :value-key="valueKey"
          @confirm="onConfirm"
          @cancel="show = false"
        />
      </van-popup>

      <div class="border" />

      <van-field name="uploader" input-align="right" label="店铺图片">
        <template #input>
          <van-uploader
            v-model="imgs"
            :max-count="8"
            multiple
            :after-read="afterRead"
            :before-delete="beforeDelete"
          >
            <div class="van-upload-btn">
              <img src="@/imgs/add.png">
              <p>上传图片</p>
            </div>
          </van-uploader>
        </template>
      </van-field>

      <div class="promise" @click="goToPromise">
        <!--我已阅读并同意《用户使用协议、推广服务协议、隐私政策》-->
        我已阅读并同意《推广服务协议》
      </div>

      <div class="footer" @click="doPublish">提交</div>
    </van-form>

    <!-- <van-popup
      v-model="showPublish"
      close-on-popstate
      closeable
      round
      position="bottom"
    >
      <div class="pay-info">
        <h1 class="pay-tip">
          {{ publishToast }}
        </h1>
        <div class="pay-type">
          <h1>选择支付方式</h1>
          <van-radio-group v-model="payData.paymentType" direction="horizontal">
            <van-radio
              :name="1"
              class="pay-type-cell"
              checked-color="#07c160"
              style="font-size: 16px;"
            >
              微信
            </van-radio>
            <van-radio
              :name="2"
              class="pay-type-cell"
              checked-color="#07c160"
              style="font-size: 16px;"
            >
              支付宝
            </van-radio>
          </van-radio-group>
        </div>
        <div class="pay-btns">
          <van-button
            class="pay-btn"
            plain
            round
            :icon="
              payData.paymentType === 1
                ? require('@/assets/wechat_pay.png')
                : require('@/assets/alipay.png')
            "
            type="primary"
            :disabled="isPublish"
            @click="doPublish(1)"
          >
            {{ payData.paymentType === 1 ? '微信' : '支付宝' }}支付
          </van-button>
          <van-button
            round
            type="warning"
            :disabled="isPublish"
            @click="doPublish(2)"
          >
            取消
          </van-button>
        </div>
      </div>
    </van-popup> -->

    <!-- <div class="platform" @click="$router.push('/platform')">
      <img src="@/assets/lianxipingtai.png">
      <p>联系平台</p>
    </div> -->

  </div>
</template>

<script>
import {Toast} from 'vant'
import lrz from 'lrz'
import {getLocation} from '@/utils/location'
import {getSession, headers} from '@/utils/util'
import {
  editPublish,
  getDistrictList,
  getPlaceOrder,
  getUserInfo,
  publish,
  transferDetail,
  uploadImg
} from '@/api/api'

export default {
  name: 'Publish',
  data() {
    return {
      show: false,
      showPublish: false,
      payType: 1,
      isPublish: false,
      publishToast: '',
      form: {
        cityName: this.$store.getters.cityName,
        districtName: '',
        trade: '',
        title: '',
        acreage: '',
        transferFee: '',
        contact: '',
        rent: '',
        phone: '',
        address: '',
        description: '',
        imgs: ''
      },
      payData: {
        redirectUrl: `${location.origin}/#/publish?pay=1`,
        feeType: 1, // 费用类型，1-推广，这里固定传1
        paymentType: 1, // 支付类型，1-微信，2-支付宝
        fee: '0.01', // 费用
        publishId: '' // 发布id
      },
      publishImg: [],
      imgs: [],
      readImg: [],
      columns: [],
      valueKey: '',
      formKey: '',
      session_id: '',
      tradeList: [],
      districtList: [],
      publishStatus: 0
    }
  },
  created() {
    this.getUserInfo()
    this.token = this.$store.getters.token
  },
  mounted() {
    this.getConfig()
    this.$store.dispatch('setTradeId', '')
    this.session_id = getSession()
    if (this.$route.query.publishId) {
      // 查看回调
      this.transferDetail(this.$route.query.publishId)
    } else {
      if (!this.$store.getters.cityName) {
        this.getLocation()
      } else {
        this.getDistrictList()
      }
    }
  },
  methods: {
    async getUserInfo() {
      const res = await getUserInfo(headers())
      if (res.data.phoneNumber) {
        this.form.phone = res.data.phoneNumber
      }
    },
    goToPromise(type) {
        this.$router.push(`/promise`)
    },
    async transferDetail(publishId) {
      const res = await transferDetail({ publishId, type: 'edit' })
      console.log(res)
      this.form = {
        publishId: res.data.publishId,
        cityName: res.data.cityName || '武汉市',
        districtName: res.data.districtName,
        title: res.data.title,
        acreage: res.data.acreage,
        transferFee: res.data.transferFee,
        contact: res.data.contact,
        rent: res.data.rent,
        phone: res.data.phone,
        address: res.data.address,
        description: res.data.description,
        imgs: res.data.imgs,
        trade: res.data.tradeName
      }
      this.tradeId = res.data.trade
      this.publishStatus = parseInt(res.data.publishStatus)
      await this.$store.dispatch('setCity', res.data.cityName || '武汉市')

      if (res.data.imgs) {
        this.imgs = res.data.imgs.split(',').map((s) => {
          return {
            content: s,
            isExist: true,
            file: {
              type: 'image/jpeg'
            }
          }
        })
      }

      this.publishImg = res.data.imgs
      this.getDistrictList()
    },
    async getConfig() {
      const data = await this.$store.dispatch('setConfig')
      this.publishToast = data.publishToast
    },
    checkPublish() {
      const reg = /^1[3456789]\d{9}$/
      const { cityName, phone } = this.form
      if (!cityName) {
        this.$notify({ type: 'warning', message: '请先选择城市' })
        return
      }
      if (!phone) {
        this.$notify({ type: 'warning', message: '请输入手机号码' })
        return
      }
      if (!reg.test(phone)) {
        this.$notify({ type: 'warning', message: '手机号码不正确' })
        return
      }
      this.showPublish = true
    },
    doPublish() {
        console.log(2222)
      if (this.isPublish) {
        return
      }

      if (this.imgs.length) {
        this.uploadImg()
        return
      }
        const { cityName, phone } = this.form
        console.log(this.form,cityName, phone)
        if (!cityName) {
            // this.$notify({ type: 'warning', message: '请先选择城市' })
            Toast('请先选择城市')
            return
        }
        if (!phone) {
            // this.$notify({ type: 'warning', message: '请输入手机号码' })
            Toast('请输入手机号码')
            return
        }
      this.publish()
    },
    async publish() {
        let formData = {}
      for(var k in this.form){
          if(k!='imgs'){
              formData[k] = this.form[k].trim()
          }else{
              formData[k] = this.form[k]
          }
      }
      let res
      let tradeId
      if (this.form.trade) {
        tradeId = this.tradeList.find((k) => k.tradeName === this.form.trade)
          .tradeId
      }

      if (this.payData.publishId) {
        this.isPublish = false
        return
      }
      try {
          this.isPublish = true
        Toast.loading({
          message: '发布中...',
          forbidClick: true,
          duration: 0,
          loadingType: 'spinner'
        })
        if (this.$route.query.publishId) {
          res = await editPublish(headers({ ...formData, trade: tradeId }), {
            ...this.form,
            trade: tradeId
          })
          console.log(res)
          Toast.clear()
          console.log(this.publishStatus)
          if (this.publishStatus === 2) {
            this.$router.go(-1)
          } else {
            await this.$store.dispatch('setPublishId', this.form.publishId)
              localStorage.setItem('formData',JSON.stringify(formData))
            this.$router.push('/pay')
          }
        } else {
          res = await publish(headers({ ...formData, trade: tradeId }), { ...formData, trade: tradeId })
          await this.$store.dispatch('setPublishId', res.data.publishId)
          await this.$store.dispatch('setPersonList', res.data.personList)
          await this.$store.dispatch('setTurnover', res.data.turnover)
          // await this.$store.dispatch(
          //   'setTradeId',
          //   tradeId || this.tradeList[0].tradeId
          // )
            console.log(res)
          Toast.clear()
              localStorage.setItem('formData',JSON.stringify(formData))
          this.$router.push('/pay')
        }
      } catch {
        Toast.clear()
        this.session_id = getSession()
        this.isPublish = false
      }
    },
    async pay() {
      try {
        const res = await getPlaceOrder(this.payData)
        const payInfo = res.data.payInfo
        // console.log(payInfo)
        if (this.payData.paymentType === 1) {
          window.location.href = payInfo
        } else if (this.payData.paymentType === 2) {
          const div = document.createElement('div')
          div.id = 'alipay'
          div.innerHTML = payInfo
          document.body.appendChild(div)
          document.querySelector('#alipay').children[0].submit() // 执行后会唤起支付宝
        }
      } catch {
        this.session_id = getSession()
      }
    },
    onBlur() {
      window.scrollTo(0, 0)
    },
    afterRead(file) {
      console.log(555)
      const that = this
      let arr = []
      if (file instanceof Array) {
        arr = file
      } else {
        arr.push(file)
      }
      arr.forEach((s) => {
        lrz(s.content, {
          quality: '0.7',
          width: '200'
        }).then(function(rst) {
          const fileSize = rst.base64Len / 1024 / 1024 // 单位为M
          if (fileSize < 3) {
            that.readImg.push(rst.base64)
          } else {
            that.readImg.push('')
          }
        })
      })
    },
    beforeDelete(file, data) {
      this.imgs.splice(data.index, 1)
      this.readImg.splice(data.index, 1)
      this.form.imgs = this.imgs.join(',')
    },
    async uploadImg() {
      const imgs = this.readImg.filter(function(s) {
        return s && s.trim()
      })
      const isExist = this.imgs.filter((s) => {
        return s.isExist
      })
      const uploadImgs = []
      let count = 0
      const allIndex = []
      const indexList = []
      Toast.loading({
        message: '上传图片中...',
        forbidClick: true,
        duration: 0,
        loadingType: 'spinner'
      })
      if (imgs.length) {
        imgs.forEach(async(s, i) => {
          allIndex.push(i + 1)
          try {
            const formData = new FormData()
            formData.append('imageString', s)
            const res = await uploadImg(formData)
            if (res.data) {
              count++
              indexList.push(i + 1)
              uploadImgs.push(res.data.fileName)
            }
          } catch {
            count++
          }
          if (count === imgs.length) {
            Toast.clear()
            if (uploadImgs.length) {
              if (isExist.length) {
                this.form.imgs = [
                  ...uploadImgs,
                  ...isExist.map((s) => {
                    return s.content
                  })
                ].join(',')
              } else {
                this.form.imgs = uploadImgs.join(',')
              }
            }
            this.publish()
          }
        })
      } else {
        Toast.clear()
        this.form.imgs = isExist
          .map((s) => {
            return s.content
          })
          .join(',')
        this.publish()
      }
    },
    async getLocation() {
      const res = await getLocation()
      if (!res || !res.data || !res.data.city) return
      this.form.cityName = res.data.city
      await this.$store.dispatch('setCity', res.data.city)
      this.getDistrictList()
    },

    async getDistrictList() {
      const res = await getDistrictList({ cityName: this.form.cityName })
      this.districtList = res.data
    },

    choose(key, valueKey, formKey) {
      this.columns = this[key]
      this.valueKey = valueKey
      this.formKey = formKey
      this.show = true
    },

    onConfirm(cell) {
      this.show = false
      this.form[this.formKey] = cell[this.valueKey]
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
  padding-bottom: 130px;
  background: #ffffff;
  z-index: 1;
  .border {
    width: 100vw;
    height: 31px;
    background: #fafafa;
  }

  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 750px;
    height: 100px;
    background: rgba(253, 106, 66, 1);
    line-height: 100px;
    text-align: center;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 800;
    color: rgba(255, 255, 255, 1);
  }

  .platform {
    position: fixed;
    bottom: 150px;
    right: 15px;
    width: 100px;
    height: 80px;
    background: #f0f0f0;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    justify-content: space-between;
    z-index: 1;
    &::after {
      content: '';
      position: absolute;
      top: 100%;
      right: 0px;
      width: 16px;
      height: 16px;
      border-width: 0;
      border-style: solid;
      border-color: transparent;
      border-left-width: 10px;
      border-left-color: currentColor;
      border-radius: 0 0 0 32px;
      color: #f0f0f0;
    }
    img {
      width: 36px;
      height: 36px;
      margin: 0 auto;
    }
    p {
      text-align: center;
      font-size: 14px;
    }
  }

  .pay-info {
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    .pay-tip {
      padding: 24px 30px;
      line-height: 36px;
      font-size: 14px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: #f04243;
      line-height: 22px;
    }
    .pay-type {
      padding: 0 30px;
      h1 {
        font-size: 16px;
        margin-bottom: 16px;
      }
      .pay-type-cell {
        margin-bottom: 16px;
      }
    }
    .pay-btns {
      padding: 0 30px;
      display: flex;
      flex-direction: row;
      .pay-btn {
        flex: 1;
        margin-right: 30px;
      }
    }
  }
  .van-upload-btn {
    margin-left: 8px;
    width: 80px;
    height: 80px;
    background: rgba(230, 230, 230, 1);
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    img {
      margin: 14px auto 4px auto;
      width: 31px;
      height: 31px;
    }
    p {
      text-align: center;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
    }
  }
  .promise {
    margin-top: 70px;
    display: flex;
    justify-content: center;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 30px;
    span {
      color: #999999;
    }
  }
}
</style>

<style>
.left-title {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(102, 102, 102, 1);
}

.van-field__control--right {
  font-family: PingFang SC;
  font-weight: 800;
  color: rgba(51, 51, 51, 1);
  text-align: left;
}

.van-uploader__wrapper {
  justify-content: flex-end;
}

.van-uploader__preview,
.van-uploader__upload {
  margin: 0 0 8px 8px;
}
  .main /deep/ .van-field__control--right{
    text-align: left;
  }
</style>
